import { isMobile } from '../utils/is-mobile';

declare global {
  interface Window {
    UserWay: any;
  }
}

export interface Services {
  noLogo: boolean;
  noManage: boolean;
  paidAi: boolean;
  siteId: number;
  userId: number;
}

const UserWay = window.UserWay;

export function resolveMainUtil(): any {
  return UserWayWidgetApp.getLib('main');
}
export function resolveUtilFunctions(): any {
  return UserWayWidgetApp.getLib('util');
}

export const getA11yHelpersState = () => {
  return resolveMainUtil().config.settings;
};

export const getConfig = () => {
  return resolveMainUtil().config;
};

export const getWidgetPosition = (): number => {
  const defaultPosition = 2;
  const position = isMobile()
    ? resolveMainUtil().config.tunings?.widget_position_mobile
    : resolveMainUtil().config.tunings?.widget_position;

  return Number(position || defaultPosition);
};

export const getNoFollowAttribute = (): string => {
  const isNoFollowAttributeEnabled =
    resolveMainUtil().config.tunings?.widget_no_follow;

  return isNoFollowAttributeEnabled ? 'rel="nofollow"' : '';
};

export const getWidgetColor = (): string => {
  const defaultColor = '#0148FF';
  const color = resolveMainUtil().config.tunings?.widget_color;

  return color || defaultColor;
};

export const getWidgetGradient = (): string => {
  const gradient = resolveMainUtil().config.tunings?.widget_color_gradient;
  return gradient !== 'off' ? gradient : null;
};

export const isColorLight = (color: string): boolean => {
  const [r, g, b] = resolveUtilFunctions().hexToRgb(color);
  const isLight = resolveUtilFunctions().colourIsLight(r, g, b);

  return isLight;
};

export const getWidgetServices = (): Services => {
  return resolveMainUtil().config.services;
};

export const a11yHelpers = {
  enableAnimation: () => UserWay.stopAnimationDisable(),
  disableAnimation: () => UserWay.stopAnimationEnable(),
  enableBigCursor: () => UserWay.bigCursorEnable(),
  disableBigCursor: () => UserWay.bigCursorDisable(),
  enableBigText: () => UserWay.bigTextToggle(),
  disableBigText: () => UserWay.bigTextDisable(),
  enableContrast: (value?: 1 | 2 | 3) => UserWay.contrastEnable(value),
  changeContrast: () => UserWay.contrastToggle(),
  disableContrast: () => UserWay.contrastDisable(),
  enableDyslexia: () => UserWay.dyslexiaFontToggle(),
  disableDyslexia: () => UserWay.dyslexiaFontDisable(),
  enableHighlight: () => UserWay.highlightToggle(),
  disableHighlight: () => UserWay.highlightDisable(),
  changeLineHeight: () => UserWay.lineHeightToggle(),
  disableLineHeight: () => UserWay.lineHeightDisable(),
  enableReadingGuide: () => UserWay.readingGuideEnable(),
  disableReadingGuide: () => UserWay.readingGuideDisable(),
  enableReadingMask: () => UserWay.readingMaskEnable(),
  disableReadingMask: () => UserWay.readingMaskDisable(),
  enableSaturation: () => UserWay.saturationToggle(),
  disableSaturation: () => UserWay.saturationDisable(),
  enableSmartContrast: () => UserWay.enableSmartContrast(),
  disableSmartContrast: () => UserWay.disableSmartContrast(),
  changeTextAlign: () => UserWay.textAlignToggle(),
  disableTextAlign: () => UserWay.textAlignDisable(),
  changeTextSpacing: () => UserWay.textSpacingToggle(),
  disableTextSpacing: () => UserWay.textSpacingDisable(),
  enableLegibleFonts: () => UserWay.legibleFontsEnable(),
  disableLegibleFonts: () => UserWay.legibleFontsDisable(),
  resetAll: () => UserWay.resetAll(),
};

export type A11yHelpers = typeof a11yHelpers;
